var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScrollToTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34772 5.68651C1.03941 6.00193 0.53954 6.00193 0.231231 5.68651C-0.0770772 5.37109 -0.0770771 4.85968 0.231231 4.54426L4.44176 0.236568C4.75007 -0.0788559 5.24993 -0.0788559 5.55824 0.236568L9.76877 4.54426C10.0771 4.85968 10.0771 5.37109 9.76877 5.68651C9.46046 6.00193 8.96059 6.00193 8.65228 5.68651L5.78947 2.75763L5.78947 13.1923C5.78947 13.6384 5.43601 14 5 14C4.56398 14 4.21053 13.6384 4.21053 13.1923L4.21053 2.75763L1.34772 5.68651Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollToTop);
export default __webpack_public_path__ + "static/media/scrollToTop.45752b58306adfb641c8ec46802c04f3.svg";
export { ForwardRef as ReactComponent };